import { render } from "./modal-edit-detail.vue?vue&type=template&id=302e8586&ts=true"
import script from "./modal-edit-detail.vue?vue&type=script&lang=ts"
export * from "./modal-edit-detail.vue?vue&type=script&lang=ts"

import "./modal-edit-detail.vue?vue&type=style&index=0&id=302e8586&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__